/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Mid } from "@mid/sdk";
import { useEffect, useState, useCallback, createContext } from "react";
import { useNavigate } from "react-router-dom";

import Loader from "../loader/login-loader";

interface McKIdProps {
    mid: Mid;
    children?: React.ReactNode;
    mockedIsAuthed?: any;
    mockLoadFlag?: any;
}

export const AuthContext = createContext({
    isAuthed: null,
    isLoading: null,
});

export const MckId: React.FC<McKIdProps> = ({ mid, children, mockedIsAuthed, mockLoadFlag }: McKIdProps) => {
    const navigate = useNavigate();
    const [isAuthed, setIsAuthed] = useState(mockedIsAuthed || false);
    const [isLoading, setIsLoading] = useState(mockLoadFlag || true);

    const checkIsAuth = useCallback(() => {
        mid.isAuthed().then((isAuth) => {
            if (isAuth) {
                setIsAuthed(true);
                setIsLoading(false);
            }
        });
    }, []);

    const login = useCallback(() => {
        mid.login().finally(() => {
            checkIsAuth();
        });
    }, [checkIsAuth]);

    useEffect(() => {
        login();
    }, [login]);

    const redirectToError = () => {
        navigate("/unauthorized");
        return null;
    };

    const content = isLoading ? <Loader blur={true} /> : isAuthed ? <>{children}</> : redirectToError();

    return (
        <AuthContext.Provider
            value={{
                isAuthed,
                isLoading,
            }}
        >
            {content}
        </AuthContext.Provider>
    );
};

export default MckId;
